export const getters = {
  mfaConfigured: (state) => {
    return state.mfaMethods.some(mfaMethod => mfaMethod.enabled)
  },
  smsMfaEnabled: (state) => {
    return state.mfaMethods.find(mfaMethod => mfaMethod.type === state.mfaTypes.SMS).enabled
  }
}
